import API, { BotVkAPI } from "./BotAPI"
import { IBotSender, IBotSenderPeer } from "./typings"


export class BotVkController {
  private readonly api: BotVkAPI

  constructor() {
    this.api = API
  }

  async sender(data: IBotSender) {
    const response = await this.api.sender(data)
    return response.data
  }

  async peer(data: IBotSenderPeer) {
    const response = await this.api.peer(data)
    return response.data
  }

  async logWrite(data: any) {
    const response = await this.api.logWrite(data)
    return response.data
  }

  async createMsg(data: any) {
    const response = await this.api.createMsg(data)
    return response.data
  }
}

export default new BotVkController()
